"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CCheckBox = _interopRequireDefault(require("01_core/components/materials/CCheckBox"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _HintMark = _interopRequireDefault(require("01_core/components/materials/HintMark"));
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _Consts = require("../../common/consts/Consts");
var _MedplanListTable = _interopRequireDefault(require("./MedplanListTable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PaddingLeft = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    paddingLeft: theme.spacing(1)
  };
});
const BorderTopRow = (0, _styles.styled)(_material.TableRow)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    borderTop: 'solid 1px',
    borderTopColor: theme.palette.border.white
  };
});
const ColumnHintMark = (0, _styles.styled)(_HintMark.default)({
  color: 'white'
});
const CenterTypography = (0, _styles.styled)(_material.Typography)({
  textAlign: 'center'
});
const TgtRiskCell = (0, _styles.styled)(_material.TableCell)({
  width: '15%'
});
const TgtRiskOtherCell = (0, _styles.styled)(_material.TableCell)({
  width: '35%'
});
const KunrenPeriodCell = (0, _styles.styled)(_material.TableCell)({
  width: '25%'
});
const StyledHelperText = (0, _styles.styled)(_material.FormHelperText)(() => ({
  marginRight: -300,
  width: 'calc(100%)'
}));

/**
 * 中期計画情報
 */
class MedplanField extends _react.default.Component {
  constructor() {
    super(...arguments);
    // チェックボックス変更時
    _defineProperty(this, "changeCheckBox", (n, key) => value => {
      var _this$props$errors;
      const list = this.props.entries.checkStatusList.slice();
      const idx = list.indexOf(n);
      if (idx >= 0) {
        list[idx] = _objectSpread(_objectSpread({}, n), {}, {
          [key]: value === true ? _CodeConsts.CODE.FLG_VALUE.CODE_1 : _CodeConsts.CODE.FLG_VALUE.CODE_0
        });
      }
      if (n.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01) {
        list.forEach((item, index) => {
          if (n.kunrenNendo === item.kunrenNendo && item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_02) {
            if (n.groupId === item.groupId) {
              list[index] = _objectSpread(_objectSpread({}, item), {}, {
                displayFlg: value === true ? true : false
              });
            }
          }
        });
      }
      // 他チェックボックスとその他欄の再チェック
      const rechecked1 = this.checkActivity(list, n.kunrenNendo);
      const rechecked2 = this.checkOtherNotes(rechecked1, n.kunrenNendo);
      this.props.setEntry('checkStatusList')(rechecked2);
      this.props.setCheckStatusList && this.props.setCheckStatusList(rechecked2);
      // 既にエラー表示中であれば、変更のたびにフォーム全体を再検証してメッセージを消す
      if ((_this$props$errors = this.props.errors) !== null && _this$props$errors !== void 0 && _this$props$errors.checkStatusList && this.props.trigger) {
        this.props.trigger();
      }
    });
    // チェックボックスその他入力値変更時
    _defineProperty(this, "changeOtherText", (n, key) => value => {
      var _this$props$errors2;
      const list = this.props.entries.checkStatusList.slice();
      const idx = list.indexOf(n);
      if (idx >= 0) {
        list[idx] = _objectSpread(_objectSpread({}, n), {}, {
          [key]: value
        });
      }

      // 他チェックボックスの再チェック
      const rechecked = this.checkActivity(list, n.kunrenNendo);
      this.props.setEntry('checkStatusList')(rechecked);
      this.props.setCheckStatusList && this.props.setCheckStatusList(rechecked);
      // 既にエラー表示中であれば、変更のたびにフォーム全体を再検証してメッセージを消す
      if ((_this$props$errors2 = this.props.errors) !== null && _this$props$errors2 !== void 0 && _this$props$errors2.checkStatusList && this.props.trigger) {
        this.props.trigger();
      }
    });
    // チェックボックスの再チェック
    _defineProperty(this, "checkActivity", (checkStatusList, kunrenNendo) => {
      let tgtRiskFlg = true;
      let kunrenPeriodFlg = true;
      let textCheck = true;
      checkStatusList.forEach(item => {
        if (item.kunrenNendo === kunrenNendo && item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01) {
          if (item.groupId === _CodeConsts.CODE.BCM_KR_GROUP.CODE_1) {
            if (item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
              tgtRiskFlg = false;
            }
          } else if (item.groupId === _CodeConsts.CODE.BCM_KR_GROUP.CODE_2) {
            if (item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
              kunrenPeriodFlg = false;
            }
          } else if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
            textCheck = item.notes ? true : false;
          }
        }
      });
      checkStatusList.forEach((item, index) => {
        if (item.kunrenNendo === kunrenNendo && item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_02) {
          if (item.groupId === _CodeConsts.CODE.BCM_KR_GROUP.CODE_1) {
            const displayFlg = !tgtRiskFlg || textCheck;
            checkStatusList[index] = _objectSpread(_objectSpread({}, item), {}, {
              displayFlg: displayFlg,
              activityFlg: displayFlg ? item.activityFlg : _CodeConsts.CODE.FLG_VALUE.CODE_0
            });
          } else if (item.groupId === _CodeConsts.CODE.BCM_KR_GROUP.CODE_2) {
            const displayFlg = !kunrenPeriodFlg || textCheck;
            checkStatusList[index] = _objectSpread(_objectSpread({}, item), {}, {
              displayFlg: displayFlg,
              activityFlg: displayFlg ? item.activityFlg : _CodeConsts.CODE.FLG_VALUE.CODE_0
            });
          }
        }
      });
      return checkStatusList;
    });
    // その他欄を再チェック
    _defineProperty(this, "checkOtherNotes", (checkStatusList, kunrenNendo) => {
      let otherInput = false;
      checkStatusList.forEach(item => {
        if (item.kunrenNendo === kunrenNendo && item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER && item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && item.notes !== '') {
          otherInput = true;
        }
      });
      checkStatusList.forEach((item, index) => {
        if (item.kunrenNendo === kunrenNendo && item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_02) {
          checkStatusList[index] = _objectSpread(_objectSpread({}, item), {}, {
            displayFlg: otherInput === true ? true : item.displayFlg
          });
        }
      });
      return checkStatusList;
    });
    // 入力値変更時
    _defineProperty(this, "changeText", (n, key) => value => {
      const medPlanList = this.props.entries.medPlanList.slice();
      const idx = medPlanList.indexOf(n);
      if (idx >= 0) {
        medPlanList[idx] = _objectSpread(_objectSpread({}, n), {}, {
          [key]: value
        });
      }
      this.props.setEntry('medPlanList')(medPlanList);
      this.props.setFormValue && this.props.setFormValue('medPlanList', medPlanList, {
        shouldValidate: false,
        shouldDirty: false
      });
    });
  }
  render() {
    const {
      intl,
      entries,
      errors
    } = this.props;
    const columns = [{
      dataKey: 'kunrenNendo',
      label: /*#__PURE__*/_react.default.createElement(PaddingLeft, null, intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_KUNREN_NENDO
      })),
      width: 150
    }, {
      dataKey: 'targetRisk',
      label: /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableHead, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, /*#__PURE__*/_react.default.createElement(_material.TableCell, {
        colSpan: 4
      }, /*#__PURE__*/_react.default.createElement(PaddingLeft, null, intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TGT_RISK
      }), /*#__PURE__*/_react.default.createElement(ColumnHintMark, {
        hint: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_TARGETRISK_HINT
      })))), /*#__PURE__*/_react.default.createElement(BorderTopRow, null, entries.th1Items.map((item, index) => {
        if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
          return /*#__PURE__*/_react.default.createElement(TgtRiskOtherCell, {
            rowSpan: 2,
            key: index
          }, /*#__PURE__*/_react.default.createElement(PaddingLeft, null, item.contents));
        } else {
          return /*#__PURE__*/_react.default.createElement(TgtRiskCell, {
            rowSpan: 2,
            key: index
          }, /*#__PURE__*/_react.default.createElement(PaddingLeft, null, item.contents));
        }
      })), /*#__PURE__*/_react.default.createElement(_material.TableRow, null))),
      width: 500
    }, {
      dataKey: 'kunrenPeriod',
      label: /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableHead, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, /*#__PURE__*/_react.default.createElement(_material.TableCell, {
        colSpan: 4
      }, /*#__PURE__*/_react.default.createElement(PaddingLeft, null, intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PERIOD
      }), /*#__PURE__*/_react.default.createElement(ColumnHintMark, {
        hint: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_KUNRENSEASON_HINT
      })))), /*#__PURE__*/_react.default.createElement(BorderTopRow, null, entries.th2Items.map((item, index) => {
        return /*#__PURE__*/_react.default.createElement(KunrenPeriodCell, {
          rowSpan: 2,
          key: index
        }, /*#__PURE__*/_react.default.createElement(PaddingLeft, null, item.contents));
      })), /*#__PURE__*/_react.default.createElement(_material.TableRow, null))),
      width: 500
    }, {
      dataKey: 'kunrenPurpose',
      label: /*#__PURE__*/_react.default.createElement(PaddingLeft, null, intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PURPOSE
      })),
      width: 230
    }, {
      dataKey: 'notes',
      label: /*#__PURE__*/_react.default.createElement(PaddingLeft, null, intl.formatMessage({
        id: _labelConsts.LABEL.CORE_NOTE
      })),
      width: 230
    }];

    // 中期計画表データ
    const createRow = n => {
      const rowIndex = entries.medPlanList.indexOf(n);
      const rowErrors = Array.isArray(errors === null || errors === void 0 ? void 0 : errors.medPlanList) ? errors.medPlanList[rowIndex] : undefined;
      //過去年度で未登録の場合
      if (n.dataRegistered === false && n.pastYearFlg === true) {
        const kunrenNendo = /*#__PURE__*/_react.default.createElement(_material.Typography, null, n.kunrenNendo, intl.formatMessage({
          id: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_KUNREN_NENDO
        }));
        const targetRisk = /*#__PURE__*/_react.default.createElement(CenterTypography, null, intl.formatMessage({
          id: _labelConsts.LABEL.BCM_KUNREN_NO_REGISTERED
        }));
        const kunrenPeriod = _stringConsts.STRING_CONSTS.EMPTY;
        const kunrenPurpose = _stringConsts.STRING_CONSTS.EMPTY;
        const notes = _stringConsts.STRING_CONSTS.EMPTY;
        const pastYearFlg = n.pastYearFlg;
        const nowYearFlg = n.nowYearFlg;
        const pastRegisterdFlg = false;
        return {
          kunrenNendo,
          targetRisk,
          kunrenPeriod,
          kunrenPurpose,
          notes,
          pastYearFlg,
          nowYearFlg,
          pastRegisterdFlg
        };
      } else {
        var _rowErrors$kunrenPurp, _rowErrors$notes;
        const targetRiskList = entries.checkStatusList.filter(item => {
          return String(item.kunrenNendo) === String(n.kunrenNendo) && item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01;
        });
        const kunrenPeriodList = entries.checkStatusList.filter(item => {
          return String(item.kunrenNendo) === String(n.kunrenNendo) && item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_02;
        });
        const kunrenNendo = /*#__PURE__*/_react.default.createElement(_material.Typography, null, n.kunrenNendo, intl.formatMessage({
          id: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_KUNREN_NENDO
        }));
        const targetRisk = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, targetRiskList.map((item, index) => {
          const origIndex = entries.checkStatusList.indexOf(item);
          if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
            if (n.pastYearFlg) {
              return /*#__PURE__*/_react.default.createElement(TgtRiskOtherCell, {
                key: index
              }, _stringUtil.default.emptyToHyphen(item.notes));
            } else {
              var _errors$checkStatusLi, _errors$checkStatusLi2;
              return /*#__PURE__*/_react.default.createElement(TgtRiskOtherCell, {
                key: index
              }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
                value: item.notes,
                onChange: v => this.changeOtherText(item, 'notes')(v),
                error: !!(errors !== null && errors !== void 0 && (_errors$checkStatusLi = errors.checkStatusList) !== null && _errors$checkStatusLi !== void 0 && (_errors$checkStatusLi = _errors$checkStatusLi[origIndex]) !== null && _errors$checkStatusLi !== void 0 && _errors$checkStatusLi.notes),
                helperText: errors === null || errors === void 0 || (_errors$checkStatusLi2 = errors.checkStatusList) === null || _errors$checkStatusLi2 === void 0 || (_errors$checkStatusLi2 = _errors$checkStatusLi2[origIndex]) === null || _errors$checkStatusLi2 === void 0 || (_errors$checkStatusLi2 = _errors$checkStatusLi2.notes) === null || _errors$checkStatusLi2 === void 0 ? void 0 : _errors$checkStatusLi2.message
              }));
            }
          } else {
            return /*#__PURE__*/_react.default.createElement(TgtRiskCell, {
              key: index
            }, /*#__PURE__*/_react.default.createElement(_CCheckBox.default, {
              checked: Number(item.activityFlg),
              onChange: n.pastYearFlg ? () => {} : this.changeCheckBox(item, 'activityFlg'),
              style: {
                cursor: n.pastYearFlg && 'default'
              },
              color: "secondary",
              labelVariant: "body2"
            }));
          }
        })))), !!(errors !== null && errors !== void 0 && errors.checkStatusList) && String(n.kunrenNendo) === String(entries.kunrenYear) && /*#__PURE__*/_react.default.createElement(StyledHelperText, {
          error: true
        }, errors.checkStatusList.message));
        const kunrenPeriod = /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, kunrenPeriodList.map((item, index) => {
          if (item.displayFlg) {
            return /*#__PURE__*/_react.default.createElement(KunrenPeriodCell, {
              key: index
            }, /*#__PURE__*/_react.default.createElement(_CCheckBox.default, {
              checked: Number(item.activityFlg),
              onChange: n.pastYearFlg ? () => {} : this.changeCheckBox(item, 'activityFlg'),
              style: {
                cursor: n.pastYearFlg && 'default'
              },
              color: "secondary",
              labelVariant: "body2"
            }));
          } else {
            return /*#__PURE__*/_react.default.createElement(KunrenPeriodCell, {
              key: index
            });
          }
        }))));
        const kunrenPurpose = n.pastYearFlg ? _stringUtil.default.emptyToHyphen(n.kunrenPurpose) : /*#__PURE__*/_react.default.createElement(_CTextField.default, {
          value: n.kunrenPurpose,
          onChange: this.changeText(n, 'kunrenPurpose'),
          maxLength: 1000,
          multiline: true,
          rows: 2,
          error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.kunrenPurpose),
          helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$kunrenPurp = rowErrors.kunrenPurpose) === null || _rowErrors$kunrenPurp === void 0 ? void 0 : _rowErrors$kunrenPurp.message
        });
        const notes = n.pastYearFlg ? _stringUtil.default.emptyToHyphen(n.notes) : /*#__PURE__*/_react.default.createElement(_CTextField.default, {
          value: n.notes,
          onChange: this.changeText(n, 'notes'),
          maxLength: 1000,
          multiline: true,
          rows: 2,
          error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.notes),
          helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$notes = rowErrors.notes) === null || _rowErrors$notes === void 0 ? void 0 : _rowErrors$notes.message
        });
        const pastYearFlg = n.pastYearFlg;
        const nowYearFlg = n.nowYearFlg;
        const pastRegisterdFlg = true;
        return {
          kunrenNendo,
          targetRisk,
          kunrenPeriod,
          kunrenPurpose,
          notes,
          pastYearFlg,
          nowYearFlg,
          pastRegisterdFlg
        };
      }
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MedplanListTable.default, {
      rowData: entries.medPlanList,
      columns,
      createRow
    }));
  }
}
var _default = exports.default = (0, _reactIntl.injectIntl)(MedplanField);